import { render, staticRenderFns } from "./saveCarExhibition.vue?vue&type=template&id=ef2d63a0&scoped=true&lang=html"
import script from "./saveCarExhibition.vue?vue&type=script&lang=js"
export * from "./saveCarExhibition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2d63a0",
  null
  
)

export default component.exports